"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseRotation = parseRotation;
exports.eagleBoolean = eagleBoolean;
exports.readEagleGrid = readEagleGrid;
exports.addMetadata = addMetadata;
const Transform_1 = require("@cadstrom/sigma-engine-shared/dist/Utils/Transform");
const Util_1 = require("../Util");
function parseRotation(value) {
    if (!value) {
        return { rot: 0, mirrored: [false, false] };
    }
    if (value.startsWith('R')) {
        return { rot: (0, Transform_1.clampRotation)(-parseFloat(value.substring(1))), mirrored: [false, false] };
    }
    if (value.startsWith('MR')) {
        return { rot: (0, Transform_1.clampRotation)(-parseFloat(value.substring(2))), mirrored: [false, true] };
    }
    return { rot: 0, mirrored: [false, false] };
}
function eagleBoolean(value, defaultValue = false) {
    switch (value?.toLowerCase()) {
        case 'yes':
        case 'on':
            return true;
        case 'no':
        case 'off':
            return false;
        default:
            return defaultValue;
    }
}
function readEagleGrid(grid, type) {
    if (!Util_1.ValidGridUnits.find((u) => u === grid._attributes.unit)) {
        if (type === 'schematic') {
            return {
                distance: 0.1,
                units: 'inch',
            };
        }
        return {
            distance: 0.01,
            units: 'mm',
        };
    }
    return {
        distance: parseFloat(grid._attributes.distance),
        units: grid._attributes.unit,
        multiple: parseInt(grid._attributes.multiple),
    };
}
function addMetadata(obj, key, value) {
    if (!value) {
        return;
    }
    if (!obj.metadata) {
        obj.metadata = {};
    }
    obj.metadata[key] = value;
}
//# sourceMappingURL=common.js.map